module.exports = __webpack_public_path__ + "media/images/icon__betPick--censored-a497d8a8781580df975175552f8a5259.png";